"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIE = function () { return !!document.documentMode; };
//# sourceMappingURL=isIE.js.map